import React, { useState } from 'react'
import {
    MotifFormField,
    MotifLabel,
    MotifTextArea,
} from "@ey-xd/motif-react";
import MotifErrorMessage from '@ey-xd/motif-react/components/forms/error-message';
import { MotifMessage } from '@ey-xd/motif-react';
import { avoidXSSattack } from 'utils/security';

const TextArea = ({ label, onChange,isError, errorMsg, maxLength, ...props}: any) => {
    const [uncontrolledValue, setUncontrolledValue] = useState('')

    const handleOnChange = (e: any) => {
        e=avoidXSSattack(e)
        setUncontrolledValue(e.target.value)
        onChange && onChange(e)
    }

    // Prefer controlled value from props if provided; fall back to internal state
    const controlledValue = props?.value !== undefined && props?.value !== null ? String(props.value) : uncontrolledValue

    return (
        <MotifFormField>
            <MotifLabel>{label}</MotifLabel>
            <MotifTextArea value={controlledValue} maxLength={maxLength} onChange={handleOnChange} {...props} />
            {maxLength && (
                <MotifMessage className='txtAlignRight'>
                    {`${controlledValue.length}/${maxLength} characters remaining`}
                </MotifMessage>
            )}
            {isError ? <MotifErrorMessage role='alert'> {errorMsg} </MotifErrorMessage> : null}
        </MotifFormField>

    )
}

export default TextArea